import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/layout/Navbar';
import { Footer } from './components/layout/Footer';
import { Home } from './pages/Home';
import { Topics } from './pages/Topics';
import { TopicDetail } from './pages/TopicDetail';
import { SectionDetail } from './pages/SectionDetail';
import { SectionQuizPage } from './pages/SectionQuizPage';
import { QuizPage } from './pages/QuizPage';
import { TrainingSummary } from './pages/TrainingSummary';
import { TrainingFull } from './pages/TrainingFull';
import { Progress } from './pages/Progress';
import { Admin } from './pages/Admin';
import { Resources } from './pages/Resources';
import { Support } from './pages/Support';
import { SelfAssessment } from './pages/SelfAssessment';
import { SelfAssessmentReview } from './pages/SelfAssessmentReview';
import { AILiteracyScan } from './pages/AILiteracyScan';
import { AILiteracyResults } from './pages/AILiteracyResults';
import { DigitalLiteracyScan } from './pages/DigitalLiteracyScan';
import { MediaLiteracyScan } from './pages/MediaLiteracyScan';
import { MediaWisdomAssessment } from './pages/MediaWisdomAssessment';
import { MediaWisdomAssessmentReview } from './pages/MediaWisdomAssessmentReview';
import { ScrollToTop } from './components/ScrollToTop';
import { CommandPalette } from './components/ui/CommandPalette';
import { ToastContainer } from './components/ui/ToastContainer';
import { useToast } from './hooks/useToast';

function App() {
  const { toasts, removeToast } = useToast();

  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen bg-gray-50">
        <Navbar />
        <main className="container mx-auto px-4 py-8">
          <Routes>
            <Route path="/" element={<Home />} />
                  <Route path="/topics" element={<Topics />} />
                  <Route path="/topics/:slug" element={<TopicDetail />} />
                  <Route path="/topics/:slug/section/:sectionIndex" element={<SectionDetail />} />
                  <Route path="/topics/:slug/section/:sectionIndex/quiz" element={<SectionQuizPage />} />
                  <Route path="/topics/:slug/kennistoets" element={<QuizPage />} />
                  <Route path="/training/summary" element={<TrainingSummary />} />
            <Route path="/training/full" element={<TrainingFull />} />
            <Route path="/progress" element={<Progress />} />
            <Route path="/self-assessment" element={<SelfAssessment />} />
            <Route path="/self-assessment/review/:attemptId" element={<SelfAssessmentReview />} />
            <Route path="/ai-literacy-scan" element={<AILiteracyScan />} />
            <Route path="/ai-literacy-scan/results/:attemptId" element={<AILiteracyResults />} />
            <Route path="/digital-literacy-scan" element={<DigitalLiteracyScan />} />
            <Route path="/media-literacy-scan" element={<MediaLiteracyScan />} />
            <Route path="/media-wisdom-assessment" element={<MediaWisdomAssessment />} />
            <Route path="/media-wisdom-assessment/review/:attemptId" element={<MediaWisdomAssessmentReview />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/support" element={<Support />} />
          </Routes>
        </main>
        <Footer />
        <CommandPalette />
        <ToastContainer toasts={toasts} onClose={removeToast} />
      </div>
    </Router>
  );
}

export default App;
